const PaymentFilters = ({ 
  filter, 
  onFilterChange, 
  onRefresh, 
  searchTerm, 
  onSearchChange,
  formTypeFilter,
  onFormTypeFilterChange,
  amountRange,
  onAmountRangeChange
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-3 space-y-2 md:space-y-0">
      <input
        type="text"
        placeholder="Search payments..."
        value={searchTerm}
        onChange={onSearchChange}
        className="border border-gray-300 rounded-md px-3 py-1 text-sm w-full md:w-64"
      />
      
      <select
        value={formTypeFilter}
        onChange={onFormTypeFilterChange}
        className="border border-gray-300 rounded-md px-3 py-1 text-sm"
      >
        <option value="all">All Form Types</option>
        <option value="DA_Arrears">DA Arrears</option>
        <option value="Arrears_Seventh">Arrears Seventh</option>
        <option value="Senior Pension Case">Pension Senior</option>
        <option value="Senior College Scale Fixation">Senior College Scale Fixation</option>
        <option value="Pension Case High School">Pension High School</option>
        <option value="New Appointment HS">New Appointment HS</option>
        {/* <option value="Pension_Current">Pension Current</option> */}
      </select>

      <select
        value={filter}
        onChange={onFilterChange}
        className="border border-gray-300 rounded-md px-3 py-1 text-sm"
      >
        <option value="all">All Statuses</option>
        <option value="pending">Pending</option>
        <option value="verified">Verified</option>
        <option value="rejected">Rejected</option>
      </select>

      <select
        value={amountRange}
        onChange={onAmountRangeChange}
        className="border border-gray-300 rounded-md px-3 py-1 text-sm"
      >
        <option value="all">All Amounts</option>
        <option value="0">Free</option>
        <option value="1-1000">₹1 - ₹1000</option>
        <option value="1001-5000">₹1001 - ₹5000</option>
        <option value="5001+">₹5001+</option>
      </select>

      <button
        onClick={onRefresh}
        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Refresh
      </button>
    </div>
  );
};

export default PaymentFilters;